import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { ChampionshipFilterItem } from 'modules/schedule/domain/interfaces/championship';
import { setChampionshipFilter } from 'modules/schedule/store';
import { selectChampionshipFilter } from 'modules/schedule/store/selectors';

/** Фильтр расписания по турнирам: выбранные турниры, смена выбора и сброс. Сбрасывается и сменой организации (слайс). */
export function useChampionshipFilter() {
  const dispatch = useAppDispatch();
  const championshipFilter = useAppSelector(selectChampionshipFilter);

  const changeChampionshipFilter = useCallback(
    (items: ChampionshipFilterItem[]) => {
      dispatch(setChampionshipFilter(items));
    },
    [dispatch],
  );

  const resetChampionshipFilter = useCallback(() => {
    dispatch(setChampionshipFilter([]));
  }, [dispatch]);

  return { championshipFilter, changeChampionshipFilter, resetChampionshipFilter };
}
